import { MultiWithModal as MultiWithModalField } from "components/FormControls/MultiWithModal";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { SelectedFilter } from "types/filters";
import { KeyValuePair } from "utilities/objects";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
  setFieldValue?: (field: string, val: any) => void;
  filter: SelectedFilter;
  setIsEditingFilters?: (val: boolean) => void;
}

export const MultiWithModal = memo(
  ({ index, size, onChange, filter, setIsEditingFilters }: Props) => {
    const { message } = useMessage();
    const classes = useStyles();
    const isInlineType = size === "inline";

    return isInlineType ? (
      <span onClick={() => setIsEditingFilters?.(true)}>
        {filter.value
          .map((item: KeyValuePair) => `(${item.key}:${item.value})`)
          .join()}
      </span>
    ) : (
      <MultiWithModalField
        disableNotifications
        formField={`filters.${index}.value`}
        placeholder={message({ id: "add" })}
        size={isInlineType ? "small" : size}
        className={
          isInlineType
            ? `${classes.inlineValue} ${classes.inlineMultiWithModal}`
            : classes.multiWithModal
        }
        data-test-id="filter-value"
        disablOnMouseDown
        onChange={onChange}
        data-hj-suppress={filter.dataHjSuppress}
      />
    );
  },
);
